import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const baseQuery = fetchBaseQuery({
    baseUrl: process.env.API_BASE_URL || '/api',
    prepareHeaders: (headers, { getState }) => {
        // 从 Redux store 获取 token
        const state = getState();
        const token = state.auth?.token;
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        headers.set('Content-Type', 'application/json');
        return headers;
    },
});
// 带重试和错误处理的 baseQuery
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result.error && result.error.status === 401) {
        // Token 过期，尝试刷新
        // 这里可以添加刷新 token 的逻辑
        // 暂时先清除认证状态
        api.dispatch({ type: 'auth/logout' });
    }
    return result;
};
// 创建基础 API
export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    tagTypes: [
        'User',
        'Work',
        'Project',
        'Topic',
        'Asset',
        'Notification',
        'Transaction',
        'Transactions',
        'Actors',
        'Casting',
        'Storyboard',
    ],
    endpoints: () => ({}),
});
